export default __webpack_public_path__ + "static/media/gamers.d8b9ea3e.jpg";